import { styled } from '@mui/material';
import LifebuoyIcon from '../../../../images/icons/lifebuoy.svg';

export const StyledLifebuoy = styled(LifebuoyIcon)`
  cursor: pointer;
`;
